"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pkgInfoFrom = pkgInfoFrom;
exports.getDependenciesFrom = getDependenciesFrom;
const utils_1 = require("./utils");
function pkgInfoFrom(manifestFileContents) {
    const parser = (0, utils_1.createManifestFileParser)(manifestFileContents);
    return parser.pkgInfoFrom();
}
function getDependenciesFrom(manifestFileContents, includeDevDependencies) {
    const parser = (0, utils_1.createManifestFileParser)(manifestFileContents, includeDevDependencies);
    return parser.getDependencies();
}
//# sourceMappingURL=manifest-parser.js.map